export var CarouselTypes;
(function (CarouselTypes) {
    CarouselTypes["default"] = "default";
    CarouselTypes["horizontal"] = "horizontal";
})(CarouselTypes || (CarouselTypes = {}));
export var CarouselBorderRadius;
(function (CarouselBorderRadius) {
    CarouselBorderRadius["all"] = "all";
    CarouselBorderRadius["none"] = "none";
    CarouselBorderRadius["top"] = "top";
    CarouselBorderRadius["left"] = "left";
})(CarouselBorderRadius || (CarouselBorderRadius = {}));
//# sourceMappingURL=constants.js.map